var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.677,
    height: 43.717,
    viewBox: "0 0 43.677 43.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.439)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.728,230.95h-8.62a1.281,1.281,0,0,0-.8.278l-6.828,5.424a1.28,1.28,0,0,0,1.29,2.184,7.04,7.04,0,0,1,9.206,3.793,1.28,1.28,0,0,0,1.181.786h4.566a1.28,1.28,0,0,0,1.28-1.28v-9.9A1.28,1.28,0,0,0,76.728,230.95Z",
    transform: "translate(-54.903 -211.239)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.244,236.652l-6.828-5.424a1.281,1.281,0,0,0-.8-.278H256v12.465h4.566a1.28,1.28,0,0,0,1.181-.786,7.04,7.04,0,0,1,9.206-3.793,1.28,1.28,0,0,0,1.29-2.184Z",
    transform: "translate(-234.175 -211.239)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.548,351.48a6.977,6.977,0,0,1,.541-2.706A1.28,1.28,0,0,0,197.908,347h-9.133a1.28,1.28,0,0,0-1.181,1.774,7.037,7.037,0,0,1,0,5.413,1.28,1.28,0,0,0,1.181,1.774h9.133a1.28,1.28,0,0,0,1.181-1.774A6.98,6.98,0,0,1,198.548,351.48Z",
    transform: "translate(-171.517 -317.384)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.206,351.48a6.977,6.977,0,0,1,.541-2.706A1.28,1.28,0,0,0,260.566,347H256v8.961h4.566a1.28,1.28,0,0,0,1.181-1.774A6.977,6.977,0,0,1,261.206,351.48Z",
    transform: "translate(-234.175 -317.384)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.58,
    cy: 9.607,
    rx: 9.58,
    ry: 9.607,
    transform: "translate(0 24.504)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.492,
    cy: 4.492,
    r: 4.492,
    transform: "translate(5.088 29.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.607,
    cy: 9.607,
    r: 9.607,
    transform: "translate(24.464 24.504)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.465,0A4.492,4.492,0,1,1,0,4.492,4.479,4.479,0,0,1,4.465,0Z",
    transform: "translate(29.605 29.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.15,0a9.328,9.328,0,0,0-9.317,9.317c0,3.054,1.512,5.069,2.726,6.688A5.477,5.477,0,0,1,151,18.74a1.28,1.28,0,0,0,1.28,1.28h7.739a1.28,1.28,0,0,0,1.28-1.28,5.477,5.477,0,0,1,1.441-2.735c1.215-1.619,2.726-3.634,2.726-6.688A9.328,9.328,0,0,0,156.15,0Z",
    transform: "translate(-134.325)",
    fill: "#faa880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,0V20.021h3.87a1.28,1.28,0,0,0,1.28-1.28,5.477,5.477,0,0,1,1.441-2.735c1.215-1.619,2.726-3.634,2.726-6.688A9.328,9.328,0,0,0,256,0Z",
    transform: "translate(-234.175)",
    fill: "#faa880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.774,98.37a1.279,1.279,0,0,1-.747-.241l-2.286-1.643a1.28,1.28,0,0,1,1.494-2.079l1.539,1.106,1.539-1.106a1.28,1.28,0,1,1,1.494,2.079l-2.286,1.643a1.279,1.279,0,0,1-.747.241Z",
    transform: "translate(-195.949 -86.13)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.326,94.7a1.28,1.28,0,0,0-1.787-.293L256,95.515v2.857a1.279,1.279,0,0,0,.747-.241l2.287-1.643A1.28,1.28,0,0,0,259.326,94.7Z",
    transform: "translate(-234.175 -86.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,219.582v4.811a1.28,1.28,0,0,0,1.28,1.28h7.739a1.28,1.28,0,0,0,1.28-1.28v-4.811Z",
    transform: "translate(-178.985 -200.842)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,219.582v6.091h3.87a1.28,1.28,0,0,0,1.28-1.28v-4.811Z",
    transform: "translate(-234.175 -200.842)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,138.435a1.274,1.274,0,0,1-.709-.215l-2.56-1.707a1.28,1.28,0,1,1,1.42-2.13l2.56,1.707a1.28,1.28,0,0,1-.711,2.345Z",
    transform: "translate(-361.463 -122.717)",
    fill: "#faa880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.447,38.434a1.28,1.28,0,0,1-.711-2.346l2.56-1.707a1.28,1.28,0,1,1,1.42,2.13l-2.56,1.707A1.274,1.274,0,0,1,396.447,38.434Z",
    transform: "translate(-361.463 -31.25)",
    fill: "#faa880"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.827 2.916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.113,138.434a1.28,1.28,0,0,1-.711-2.346l2.56-1.707a1.28,1.28,0,1,1,1.42,2.13l-2.56,1.707A1.273,1.273,0,0,1,58.113,138.434Z",
    transform: "translate(-56.831 -125.632)",
    fill: "#faa880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.67,38.436a1.274,1.274,0,0,1-.709-.215L57.4,36.514a1.28,1.28,0,1,1,1.42-2.13l2.56,1.707a1.28,1.28,0,0,1-.711,2.345Z",
    transform: "translate(-56.831 -34.168)",
    fill: "#faa880"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.63d48d03d83b1d111edc0191800e6052.svg";
export { ForwardRef as ReactComponent };